import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

const selectEarlyShopping = createSelector(
  (state) => state.shopping || {},
  (shopping) => ({
    includeEarlyShopperMessage: shopping.includeEarlyShopperMessage || false,
    earlyShopperLink: shopping.earlyShopperLink || "",
    earlyShoppingImage: shopping.earlyShoppingImage || null,
  })
);

export default function useEarlyShopping() {
  return useSelector((state) => selectEarlyShopping(state));
}
